<script>
export default {
  name: 'MonitorNode',

  components: {},

  props: {
    value: {
      type:     Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
};
</script>

<template>
  <div>
    Monitor
  </div>
</template>

<style lang="scss" scoped>

</style>
